import fetch from 'src/http/fetch'

// 头条新闻
export function headlinesNews () {
  return fetch('stadium/news', {
    headlines: true,
    pageNo: 1,
    pageSize: 2
  })
}

// 热点新闻
export function hotspotNews () {
  return fetch('stadium/news', {
    hotspot: true,
    pageNo: 1,
    pageSize: 2
  })
}

// 新闻列表
export function news (sort, pageNo, pageSize) {
  return fetch('stadium/news', {
    sort: sort,
    pageNo: pageNo,
    pageSize: pageSize
  })
}

// 新闻列表
export function newsDetail (id) {
  return fetch('stadium/news/detail', {
    id: id
  })
}

// 新闻分类
export function sorts () {
  return fetch('stadium/news/sorts', {})
}



// WEBPACK FOOTER //
// ./src/api/stadiumApi.js